module.exports = __webpack_public_path__ + "img/barIcon7.ab038dd0.png";